import type { TourDefinition } from '../types';
import { TOUR_IDS } from '../types';

export const createOrganizationTour: TourDefinition = {
  id: TOUR_IDS.CREATE_ORGANIZATION,
  steps: [
    {
      target: '[data-tour="create-org-header"]',
      titleKey: 'createOrganization.welcome.title',
      contentKey: 'createOrganization.welcome.content',
      placement: 'bottom',
      skipBeacon: true,
    },
    {
      target: '[data-tour="create-org-media"]',
      titleKey: 'createOrganization.media.title',
      contentKey: 'createOrganization.media.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="create-org-name"]',
      titleKey: 'createOrganization.name.title',
      contentKey: 'createOrganization.name.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="create-org-slug"]',
      titleKey: 'createOrganization.slug.title',
      contentKey: 'createOrganization.slug.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="create-org-bio"]',
      titleKey: 'createOrganization.bio.title',
      contentKey: 'createOrganization.bio.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="create-org-phone"]',
      titleKey: 'createOrganization.phone.title',
      contentKey: 'createOrganization.phone.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="create-org-submit"]',
      titleKey: 'createOrganization.submit.title',
      contentKey: 'createOrganization.submit.content',
      placement: 'top',
    },
  ],
};
